import Drawer from '../../../components/common/Drawer'
import Input from '../../../components/form/input/InputField'
import { useBusiness } from '../../../context/BusinessContext'
import { useCommon } from '../../../context/CommonContext'
import { businessFilter } from '../../../functions/businessFilter'
import Filter from './Filter'

const BusinessDrawerFilter = ({ open, handleClose }: { open: boolean; handleClose: () => void }) => {
    const { business, setFilteredBusiness, setOpenFilter, filters, setFilters, clearFilters } = useBusiness()
    const { filtersOptions } = useCommon()

    const handleFilter = () => {
        const filteredBusiness = businessFilter(business, filters)
        setFilteredBusiness(filteredBusiness)
        setOpenFilter(false)
    }

    if (!open) return null

    return (
        <Drawer
            open={open}
            handleClose={handleClose}
            title='Filtros'
            handleFilter={handleFilter}
            handleClean={clearFilters}
            maxWidth='max-w-2xl'
        >
            <div className='space-y-4'>
                <Input
                    type='text'
                    name='search'
                    placeholder='Pesquisar'
                    value={filters.search}
                    onChange={e => setFilters({ ...filters, search: e.target.value })}
                />
                <Filter title='Etiquetas' type='targets' selecteds={filters.targets} options={filtersOptions.targets} />
                <Filter
                    title='Responsáveis'
                    type='creators'
                    selecteds={filters.creators}
                    options={filtersOptions.creators}
                />
                <Filter
                    title='Empresas'
                    type='companies'
                    selecteds={filters.companies}
                    options={filtersOptions.companies}
                />
            </div>
        </Drawer>
    )
}

export default BusinessDrawerFilter
